<template>
    <div :class="addtlClass">
        <label :for="name" v-if="label" class="flex items-center mb-1.5 text-sm font-medium text-gray-900 dark:text-white" :class="labelClass">
            {{ label }}<small v-if="small" class="ml-2 font-normal text-slate-600 dark:text-slate-400">{{ small }}</small>:
            <button v-if="copy" @click="$copyToClipboard($event, modelValue)" class="ml-auto mr-2"><font-awesome-icon :icon="['far', 'copy']" class="text-lg" /></button>
        </label>
        <Field
            :as="as"
            :name="name"
            class="bg-gray-50 h-10 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 placeholder-gray-400 dark:text-white disabled:opacity-50 disabled:cursor-not-allowed"
            :type="type"
            :modelValue="modelValue"
            @update:modelValue="handleUpdate"
            @change="$emit('change', $event)"
            :placeholder="placeholder"
            :rules="rules"
            :disabled="disableField"
            :readonly="readonlyField"
            :autocomplete="autoComplete"
            :class="addtlInputClass"
        />
        <ErrorMessage :name="name" class="basis-full text-xs tracking-wide text-red-600 dark:text-red-300 m-1" />
    </div>
</template>

<script setup>
    import { Field, ErrorMessage } from 'vee-validate';

    defineProps({
        modelValue: {
            type: [String, Object, Number],
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        name: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
        labelClass: {
            type: String,
            default: "",
        },
        rules: {
            type: String,
            default: "",
        },
        as: {
            type: String,
            default: null
        },
        type: {
            type: String,
            default: "text"
        },
        disableField: {
            type: Boolean,
            default: false
        },
        readonlyField: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: String,
            default: "",
        },
        addtlClass: {
            type: String,
            default: ""
        },
        addtlInputClass: {
            type: String,
            default: ""
        },
        copy: {
            type: Boolean,
            default: false
        },
        small: String
    })

    const emit = defineEmits(['update:modelValue', 'change'])

    const handleUpdate = (value) => {
        emit('update:modelValue', value)
    }
</script>


<style scoped>

</style>
